import { getEnv, Instance } from 'mobx-state-tree';
import { createBasePredictionStoreMST } from 'modules/Predictions/mst/basePredictionStore';
import { action, effect, types } from 'mst-effect';
import type { QueryClient } from 'react-query';
import { tap, map, mergeMap, debounceTime, filter } from 'rxjs';
import { CachedPostModelPredictBody, makeModelPredict$ } from 'modules/Predictions/effects';
import { either } from 'fp-ts';
import { pipe } from 'utils/fp';
import { withTrainingLogWindows } from 'modules/Models/stores/trainingLogsStore/TrainingLogsStore';

export const ModelPredictionsStoreMST = types
  .compose(createBasePredictionStoreMST<CF.API.Models.Model>(), withTrainingLogWindows())
  .actions((self) => {
    return {
      predict: effect<CF.API.ModelOutputs.PostModelPredictBody | CachedPostModelPredictBody | undefined>(self, (payload$) =>
        payload$.pipe(
          filter(Boolean),
          tap(() => self.setLoading()),
          debounceTime(120),
          mergeMap(
            makeModelPredict$({
              model: self.entity.data,
              getVersionId: () => self.viewState.selectedVersionId,
              getDeploymentId: () => self.viewState.selectedDeploymentId,
              queryClient: getEnv<{ queryClient: QueryClient }>(self).queryClient,
            }),
          ),
          map((outputE) =>
            action(() => {
              self.outputE = pipe(
                outputE,
                // convert model prediction item to an array of 1 item so as to keep same schema for both Model Workflow prediction
                either.map((x) => [x]),
              );
            }),
          ),
        ),
      ),
    };
  });

export type IModelPredictionStoreMST = Instance<typeof ModelPredictionsStoreMST>;
